import { combineReducers } from '@reduxjs/toolkit';

import { authReducer } from '@/features/auth';
import { baseApi } from '@/services/api/baseApi';

import { uiReducer } from './slices/uiSlice';

/**
 * Root reducer.
 *
 * Slices are domain-oriented and deliberately few. Redux holds only state that
 * is genuinely global — the session, cross-cutting UI chrome, and the RTK
 * Query cache. Component-local state stays in components; putting it here
 * would widen the update surface and cause unrelated rerenders.
 */
export const rootReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  auth: authReducer,
  ui: uiReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
